import { render, staticRenderFns } from "./BaseFormModal.vue?vue&type=template&id=a7fc2202&"
import script from "./BaseFormModal.vue?vue&type=script&lang=js&"
export * from "./BaseFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports